import { render, staticRenderFns } from "./TriggerButton.vue?vue&type=template&id=a1de53a0&scoped=true"
import script from "./TriggerButton.vue?vue&type=script&lang=js"
export * from "./TriggerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1de53a0",
  null
  
)

export default component.exports